import { apiClient, extractData } from './client';
import type { User } from '@/types';

export interface LoginPayload { email: string; password: string }
export interface RegisterPayload { email: string; password: string; name: string }
export interface AuthResult { user: User; accessToken: string; refreshToken: string }

// Shape the backend actually returns for login/register
interface AuthApiResult {
  user: User;
  tokens: { accessToken: string; refreshToken: string };
}

function flattenAuthResult(raw: AuthApiResult): AuthResult {
  return { user: raw.user, accessToken: raw.tokens.accessToken, refreshToken: raw.tokens.refreshToken };
}

export const authApi = {
  login: (data: LoginPayload) =>
    apiClient.post<{ data: AuthApiResult }>('/auth/login', data)
      .then(res => flattenAuthResult(res.data.data)),
  register: (data: RegisterPayload) =>
    apiClient.post<{ data: AuthApiResult }>('/auth/register', data)
      .then(res => flattenAuthResult(res.data.data)),
  logout: (refreshToken: string) =>
    apiClient.post('/auth/logout', { refreshToken }),
  me: () =>
    apiClient.get<{ data: User }>('/auth/me').then(extractData),
  listUsers: () =>
    apiClient.get<{ data: User[] }>('/settings/users').then(extractData),
  updateUserRole: (userId: string, role: string) =>
    apiClient.patch<{ data: User }>(`/settings/users/${userId}/role`, { role }).then(extractData),
  deactivateUser: (userId: string) =>
    apiClient.patch<{ data: User }>(`/settings/users/${userId}/deactivate`).then(extractData),
};
